import React, {useContext} from "react";
import {createGlobalStyle} from "styled-components";

import Header from "../Header";
import Footer from "../Footer";
import Content from "../Content";
import HeaderContainer from "../HeaderContainer";
import BuilderContext from "../../../context/BuilderContext"

import {BE_ADDR} from "../../../api/host";

export const resolveBkgImage = (pathDesk, pathMobile, widthPx) => {
    const emptyPaths = ((pathDesk === "" || pathMobile === "") && pathDesk === pathMobile)
    const useMobForDesk = (!emptyPaths && pathDesk === "")
    const useDeskForMob = (!emptyPaths && pathMobile === "")
    // debugger
    if (emptyPaths) {return}
    if (useMobForDesk) {
        return `background-image: url("${BE_ADDR + pathMobile}"); background-size: cover; background-position: center;`
    }
    if (useDeskForMob) {
        return `background-image: url("${BE_ADDR + pathDesk}"); background-size: cover; background-position: center;`
    }
    return `background-image: url(${BE_ADDR + pathMobile}); background-size: cover; background-position: center;
    @media screen and (min-width: ${widthPx}px) {
        background-image: url(${BE_ADDR + pathDesk});
    }`
}

export const GlobalStyle = createGlobalStyle`
  body, html {
    text-align: center;
    color: ${props => props.style.color_text} !important;
    background-color: ${props => props.style.bkg_color} !important;
    ${props => (props.style.bkg_repeat) ? 'background-repeat: repeat !important;':''}
    ${props => props.bgImages}
  }
  .nowrap { color: ${props => props.style.color_text} !important;}
  a {         color: ${props => props.style.color_text};}
  a:hover {   color: ${props => props.style.color_text};}
  a:active {  color: ${props => props.style.color_text};}
  a:visited { color: ${props => props.style.color_text};}
  .main-txt-pref { color: ${props => props.style.color_text};}
  #myBarText { color: ${props => props.style.color_text};}
  .pietimer > .percent { color: ${props => props.style.color_text};}
  .pietimer > .slice > .pie { border-color: ${props => props.style.color_text} !important;}
  .main-font-style {
    ${props => !(props.mode)  
    ? `font-size: ${props.style.font_size}px !important;
    font-weight: ${props.style.font_weight} !important;
    font-style: ${props.style.font_style} !important;
    font-family: ${props.style.font_name} !important;` 
    : `${props.style.font_custom}` }
  }
  .welcome-mess {
    color: ${props => props.style.adv_color_text} !important; 
    font-size: ${props => props.style.welcome_mess_font}px !important;
  }
  .btn {
    font-size: ${props => props.style.btn_font}px !important;
    color: ${props => props.style.btn_txt_color} !important;
    border-radius: ${props => props.style.radius_btn} !important;
    border-style: solid;
    border-width: ${props => props.style.btn_border_px} !important;
    background-color: ${props => props.style.color_btn} !important;
    border-color: ${props => props.style.btn_brd_color} !important;
  }
  .btn:hover {
    background-color: ${props => props.style.color_btn_h} !important;
    color: ${props => props.style.btn_txt_color} !important;
  }
  .progress-bar {
    background-color: ${props => props.style.color_btn} !important;
  }
  .masked {
    ${props => props.style.mask && ({
      backgroundColor: props.style.mask_color,
    })
  }
  }
  .element-radius {
    border-radius: ${props => props.style.radius_btn} !important;
  }
  p>a {color: ${props => props.style.btn_txt_color} !important;}
  .content {
  ${props => (props.style.mask) ? `.content {background-color: ${props => props.style.mask_color} !important; }`:'' }
    border-radius: ${props => props.style.radius_btn} !important;
  }
  .insert-field {
    border-radius: ${props => props.style.radius_btn} !important;
  }
  .logo-hat-top { width: ${props => props.style.logo_1_width} !important;}
  .logo-hat-center { width: ${props => props.style.logo_1_width} !important;}
  #container {
  ${props => (props.style.container_space !== "") && ({
    display: "flex",
    flexDirection: "column",
    justifyContent: props.style.container_space,
    height: "100%"
  })
  }
  }
  #footer > a {
    color: ${props => props.style.color_text} !important;
  }
  .element-border { width: ${props => props.style.btn_width} !important;}
  @media screen and (min-width: 720px) {
    .logo-hat-center { max-width: calc(${props => props.style.logo_1_width} + 100px) !important;}
    .welcome-mess { font-size: calc(${props => props.style.welcome_mess_font}px + 10px) !important; }
    .element-border { width: calc(${props => props.style.btn_width} + 100px) !important; }
    .btn { font-size: calc(${props => props.style.btn_font}px + 3px) !important; }
  }
  @media screen and (min-width: 1024px) {
    .logo-hat-center { max-width: calc(${props => props.style.logo_1_width} + 200px) !important;}
    .welcome-mess { font-size: calc(${props => props.style.welcome_mess_font}px + 15px)!important; }
    .element-border { width: calc(${props => props.style.btn_width} + 140px) !important; }
    .btn { font-size: calc(${props => props.style.btn_font}px + 5px) !important; }
  }
  @media screen and (min-width: 1440px) {
    .welcome-mess { font-size: calc(${props => props.style.welcome_mess_font}px + 20px) !important; }
    .btn { font-size: calc(${props => props.style.btn_font}px + 7px) !important; }
  }
  .logo-bot-center { width: ${props => props.style.logo_2_width} !important;}
  .img-header-center { width: ${props => props.style.welcome_img_width} !important;}
`

const SkinBlock = () => {
    const { style, label } = useContext(BuilderContext)

    if (label === "MF" && style.id === 0) {
        import('../../Label/megafon.css')
    } else if (label === "NBN" && style.id === 0) {
        import('../../Label/netbynet.css')
    } else {
        import('../../Label/default.css')
    }

    return (
        <div className='App main-font-style'>
            <link rel="stylesheet" href={`${BE_ADDR}/fonts/main.css`}/>
            <link rel="stylesheet" href={style.fonts_css_path}/>
            <GlobalStyle
                style = {style}
                bgImages={resolveBkgImage(style.img_desktop_path, style.img_mobile_path, style.img_point)}
            />
            <HeaderContainer style={style}/>
            <div
                id="container"
                className="content masked element-radius"
            >
                <Header />
                <Content />
                <Footer style={style}/>
            </div>
        </div>
    )
}

export default SkinBlock